import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';


import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


class ScrollReveal {
  constructor(options){
    this.options = options;
  }

  reveal(el, options, duration){
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire( el, function(){
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options,args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //モーダル
    function originmodal() {

      //モーダルを開いた時のスクロール位置を保持
      var scrollPosition;
      //iOS（iPadOSを含む）かどうかのUA判定
      var ua = window.navigator.userAgent.toLowerCase();
      var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

      //bodyのスクロール固定
      function bodyFixedOn() {
        if(isiOS){
          // iOSの場合
          scrollPosition = $(window).scrollTop();
          $('body').css('position', 'fixed');
          $('body').css('top', '-' + scrollPosition + 'px');
        }else {
          // それ以外
          $('body').css('overflow', 'hidden');
        }
      }

      //bodyのスクロール固定を解除
      function bodyFixedOff() {
        if(isiOS){
          // iOSの場合
          $('body').css('position', '');
          $('body').css('top', '');
          $(window).scrollTop(scrollPosition);
        }else {
          // それ以外
          $('body').css('overflow', '');
        }
      }

      $('.js-scan-modal').on('click', function (e) {
        const $item = $(this);
        const modalId = $item.data("teacher-target");
        const $modal = $('.c-scan-modal[data-teacher-content="' +  modalId + '"]');

        e.preventDefault();

        if ($modal.hasClass("is-active")) {
          $modal.removeClass('is-active');
          $modal.addClass("is-hidden");
          bodyFixedOff();
          setTimeout(() => {
            $modal.removeClass("is-hidden");
          }, 500);
        } else {
          $modal.addClass('is-active');
          bodyFixedOn();
        }
      });


      $('.c-scan-modal__close, .c-scan-modal__overlay').on('click', function (e) {
        const $modal = $(this).parents('.c-scan-modal');
        $modal.removeClass('is-active');
        $modal.addClass("is-hidden");
        bodyFixedOff();
        setTimeout(() => {
          $modal.removeClass("is-hidden");
        }, 500);
      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual-one__slider.owl-carousel').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
          // navText: ['<img src="/wp-content/themes/uluru-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/uluru-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });

      // Top page block-top-apps
      owls.imagesLoaded(function () {
        if ($('.c-banner-top__slider').find('.c-banner-top__item').length < 3){
          $('.c-banner-top__slider').toggleClass('owl-carousel');
          return false;
        }
        $('.c-banner-top__slider').owlCarousel({
          margin: 36,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: true,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 14,
            },
            // breakpoint from 750 up
            750: {
              items: 1,
            }
          }
        });
      });

      // Top page box-slider-three-col
      owls.imagesLoaded(function () {
        var win = $(window).innerWidth();
        if (win > 750) {
          $('.c-card-case__slider').toggleClass('owl-carousel');
          return false;
        }

        if ($('.c-card-case').find('.c-card-case__item').length < 2){
          $('.c-card-case__slider').toggleClass('owl-carousel');
          return false;
        }

        $('.c-card-case__slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1000,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            }
          }
        });
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-card-slider').find('.c-card__block').length < 3){
          $('.js-card-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/uluru-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/uluru-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }
    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '8';

      sr.reveal(".c-main-visual,.l-page-header", {
        duration: 1400,
        opacity: 1,
        //translateY: -baseDistance,
        delay: 900,
      }, 100);

      sr.reveal(".c-solution__wrap  > *",{
        scale: [0.9, 1],
        opacity: 1,
        duration: 600,
        delay: anime.stagger(100),
        translateX: [-baseDistance,0],
        easing: baseEasing
      });
      domEach(".c-card-sm__block", function(key, item){

        sr.reveal(item,{
          scale: {
            value: [0.9,1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100*key,
          translateY: [-baseDistance,0],
          easing: baseEasing
        } );
      });
    }



    // slick
    function slickSlider() {
      $(function () {
        $(".c-loop-slider__inner.is-top").slick({
          autoplay: true, //自動でスクロール
          autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
          speed: 4000, //スライドが流れる速度を設定
          cssEase: "linear", //スライドの流れ方を等速に設定
          slidesToShow: 1, //表示するスライドの数
          swipe: false, // 操作による切り替えはさせない
          arrows: false, //矢印非表示
          pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
          pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
          variableWidth: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                // slidesToShow: 8,
              },
            },
          ],
        });

        $(".c-loop-slider__inner.is-bottom").slick({
          autoplay: true, //自動でスクロール
          autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
          speed: 4000, //スライドが流れる速度を設定
          cssEase: "linear", //スライドの流れ方を等速に設定
          slidesToShow: 1, //表示するスライドの数
          swipe: false, // 操作による切り替えはさせない
          arrows: false, //矢印非表示
          pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
          pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
          variableWidth: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                // slidesToShow: 8,
              },
            },
          ],
        });

        let $main,$thumb;
        $(".c-block-institution__slick").each(function(i,e) {
          $main = $(e).find('.c-block-institution__main');
          $thumb = $(e).find('.c-block-institution__thumbnail');
          // 上段
          $main.slick({
            infinite: true,
            arrow: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '0',
            prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
            nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
            asNavFor: $thumb,
            autoplaySpeed: 3500,
            centerMode: true,
            variableWidth: false,
            dots: true,
            responsive: [{
              breakpoint: 750,
              settings: {}
            }]
          });

          // 下段
          $thumb.slick({
            accessibility: true,
            autoplay: true,
            autoplaySpeed: 3500,
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            asNavFor: $main,
            focusOnSelect: true,
            responsive: [{
              breakpoint: 950,
              settings: {}
            },
              {
                breakpoint: 750,
                settings: {
                  variableWidth: false,
                  slidesToShow: 5
                }
              }]
          });
        });
      });
    }

    // ループスライダー
    function infiniteSlider() {
      const optionInfinite = {
        infinite: true,
        arrows: false,
        swipe: false,
        dots: false,
        variableWidth: true,  // スライド幅の自動計算を無効
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        pauseOnFocus: false,
        pauseOnHover: false
      }
      const slickInfinite = $('.js-infinite-slider');
      if (slickInfinite) $(slickInfinite).slick(optionInfinite);
    }

    $(function () {
      menuSlide();
      originmodal();
      owlCarousel();
      reveal();
      slickSlider();
    });
  }
}

window.GApp = new App();
